import React from 'react';
import SEO from '@/components/SEO';

export default function TermsPage() {
    return (
        <>
            <SEO title="Uvjeti korištenja | Škobić Keramika" noindex />
            <div className="sk-section">
                <div className="sk-container max-w-3xl sk-prose">
                    <h1 className="font-display text-4xl mb-4">Uvjeti korištenja</h1>
                    <p>Ova stranica je u pripremi. Korištenjem ovog web sajta prihvaćate uvjete korištenja koji su uskoro dostupni.</p>
                </div>
            </div>
        </>
    );
}
